let registrationPromise;

export function register() {
  if (process.env.NODE_ENV !== "production") return undefined;
  if (!("serviceWorker" in navigator)) return undefined;

  const registerServiceWorker = async () => {
    try {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      registrationPromise = navigator.serviceWorker.register(swUrl);
      const registration = await registrationPromise;
      console.log("Service worker registrado com sucesso!", registration);
      return registration;
    } catch (error) {
      registrationPromise = undefined;
      console.error("Erro durante o registro do service worker:", error);
      return undefined;
    }
  };

  if (document.readyState === "complete") return registerServiceWorker();
  window.addEventListener("load", registerServiceWorker, { once: true });
  return undefined;
}

export async function getRegistration() {
  if (!("serviceWorker" in navigator)) return undefined;
  const existingRegistration = await navigator.serviceWorker.getRegistration();
  if (existingRegistration) return existingRegistration;
  if (registrationPromise) return registrationPromise;
  return register();
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error("Erro durante o desregistro do service worker:", error);
      });
  }
}
